<template>
  <transition name="ph-fade-in">
    <div
      v-if="show"
      class="ph-dialog"
      :class="{
        'ph-dialog--has-cancel': showCancelButton,
        'ph-dialog--has-title': showTitle,
      }"
      :style="{ 'z-index': actualZIndex }"
    >
      <h2 v-if="showTitle" class="ph-dialog__header">
        <slot name="header" v-bind="{ close: close }">
          <span class="ph-dialog__title">
            <slot name="title">
              {{ title }}
            </slot>
          </span>
          <i class="ph-dialog__close"></i>
        </slot>
      </h2>
      <div v-if="content" class="ph-dialog__content">{{ content }}</div>
      <div class="ph-dialog__footer">
        <slot name="footer">
          <ph-button
            v-if="showCancelButton"
            class="ph-dialog__button"
            @click="onCancel"
          >
            {{ cancelText }}
          </ph-button>
          <ph-button
            class="ph-dialog__button"
            type="primary"
            :disabled="confirmDisabled"
            @click="onConfirm"
          >
            {{ confirmText }}
          </ph-button>
        </slot>
      </div>
    </div>
  </transition>
</template>
<script>
import PhButton from "./button";
import mixin from "@components/mixins/popup";

export default {
  name: "PhDialog",
  mixins: [mixin],
  components: { PhButton },
  props: {
    showCancelButton: {
      type: Boolean,
      required: false,
      default: false,
    },
    title: {
      type: String,
      required: false,
      default: "",
    },
    content: {
      type: String,
      required: false,
      default: "",
    },
    showTitle: {
      type: Boolean,
      required: false,
      default: true,
    },
    closeOnMaskClick: {
      type: Boolean,
      required: false,
      default: false,
    },
    confirmText: {
      type: String,
      required: false,
      default: "确定",
    },
    cancelText: {
      type: String,
      required: false,
      default: "取消",
    },
    confirmDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    confirm: {
      type: Function,
      required: false,
      default: function () {
        return Promise.resolve();
      },
    },
    appendToBody: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  watch: {
    iShow: {
      handler: function (val) {
        if (val) {
          if (this.appendToBody) {
            document.body.appendChild(this.$el);
          }
        }
      },
      immediate: true,
    },
  },
  beforeDestroy() {
    if (this.appendToBody && this.$el && this.$el.parentNode) {
      document.body.appendChild(this.$el);
    }
  },
  methods: {
    onCancel() {
      this.$emit("cancel");
      this.close();
    },
    onConfirm() {
      if (this.confirmDisabled) {
        return;
      }
      this.$emit("confirm");
      if (typeof this.confirm === "function") {
        this.confirm()
          .then(() => {
            this.close();
          })
          .catch((error) => {
            console.error(error);
          });
      } else {
        this.close();
      }
    },
  },
};
</script>
